export default {
    Get: {
        GET_NOTIFICATIONS: 'getNotifications',
    },
    Set: {
        ADD_NOTIFICATIONS: 'addNotifications',
        REMOVE_NOTIFICATIONS: 'removeNotifications',
    },
    Service: {
    }
};